import type { ReactNode } from 'react'
import { PointSelector } from 'shared/components/point-selector'
import { useTranslate } from 'shared/lib/i18n'
import { actsAsAdmin } from 'shared/lib/roles'
import { useAuthStore } from 'shared/store/auth'

/**
 * The row above a money page: the admin's Point picker on the left, the page's main
 * button on the right. An operator has one Point, so the row holds only the button.
 */
export function Toolbar({ action }: { action?: ReactNode }) {
	const { t } = useTranslate()
	const isAdmin = actsAsAdmin(useAuthStore((s) => s.user.role))
	if (!isAdmin && !action) return null
	return (
		<div className='flex flex-wrap items-center justify-between gap-3'>
			{isAdmin ? (
				<PointSelector
					id='money-point'
					testId='money-point'
					label={t('money.selectPoint')}
					placeholder={t('money.pointPlaceholder')}
					className='flex items-center gap-2'
				/>
			) : null}
			{action ? <div className='ml-auto flex items-center gap-2'>{action}</div> : null}
		</div>
	)
}
